/**
 * Copyright 2025 IBM Corp.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BaseCache } from "@/cache/base.js";

export class NullCache<T> extends BaseCache<T> {
  enabled = false;

  async set(_key: string, _value: T) {}

  async get(_key: string) {
    return undefined;
  }

  async has(_key: string) {
    return false;
  }

  async delete(_key: string) {
    return true;
  }

  async clear() {}

  async size() {
    return 0;
  }

  createSnapshot() {
    return {
      enabled: this.enabled,
    };
  }

  loadSnapshot(snapshot: ReturnType<typeof this.createSnapshot>) {
    Object.assign(this, snapshot);
  }
}
